var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.71693L11.3032 6.18024L10.5896 6.91535L6.35839 2.56587L6 2.19746L5.64161 2.56587L1.41039 6.91535L0.696821 6.18024L6 0.71693Z",
    fill: "#C4CED6",
    stroke: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBase);
export default __webpack_public_path__ + "static/media/chevron-up_base.2ae5a58952a350538bc309da3c79c66d.svg";
export { ForwardRef as ReactComponent };